module.exports = __webpack_public_path__ + "static/img/qr-code.828714c.png";


//////////////////
// WEBPACK FOOTER
// ./static/moblieHome/qr-code.png
// module id = KQsu
// module chunks = 1